import { AxiosRequestConfig } from 'axios';
import { getEmployeeId } from '../sessionStorage';
import { getToken } from '../token';

export const getAuthorizationHeaders = () => {
  const token = getToken();
  if (token) {
    return {
      Authorization: `Bearer ${token}`,
    };
  } else return {};
};

export const getEmployeeIdHeader = () => {
  const employeeId = getEmployeeId();
  if (employeeId) {
    return {
      employeeId,
    };
  } else return {};
};

export const setAuth = (config: AxiosRequestConfig) => {
  const { headers = {} } = config;

  config.headers = {
    ...headers,
    ...getAuthorizationHeaders(),
    ...getEmployeeIdHeader(),
  };
};
